(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/your-account', {
      templateUrl: 'modules/app/settings/your-account/your-account.html',
      controller: 'MyAccountSettingsCtrl'
    });
  }]).controller('MyAccountSettingsCtrl', ['$scope', "Utils", function ($scope) {
    $scope.$emit("headline:change", "Settings");
    $scope.$emit("nav:change", "settings");
    $scope.section = "your-account";
  }]).
  /**
   * My Account Page
   */
  controller('MyAccountCtrl', ['$scope', '$rootScope', '$timeout', '$uibModal', 'User', 'Api', 'Alerts', '$http', 'Utils', 'Validation', 'Logger', function ($scope, $rootScope, $timeout, $uibModal, User, Api, Alerts, $http, Utils, Validation, Logger) {
    $scope.timezoneNames = moment.tz.names();
    $scope.clearUserTimeZone = function () {
      $scope.editCopy.timezone = null;
    };
    $scope.user = User.get();

    //see if user is Unsubscribed from emails
    $http.post(Api.url("/email-blacklist/get-by-email", true), $scope.user.user.email).then(function success() {
      $scope.userIsUnsubscribed = true;
    }, function error() {
      $scope.userIsUnsubscribed = false;
    });
    function updateUserScope() {
      $scope.entity = _.extend({}, $scope.user.user, {
        membership: {
          user: $scope.user.user
        }
      });
    }
    updateUserScope();
    $scope.hideBackButton = true;
    $scope.showRequirementsText = false;

    //set these two properties to be used by uploadImageModal
    $scope.uploadUrl = '/images';
    $scope.isUserImage = true;
    $scope.showUploadImageModal = function () {
      $scope.uploadImageModal = $uibModal.open({
        templateUrl: "modules/common/images/upload-image-modal.html",
        controller: "UploadImageCtrl",
        backdrop: 'static',
        scope: $scope
      });

      // The modal "resolves" to (closes with) image url
      $scope.uploadImageModal.result.then(function (imageUrl) {
        $scope.editCopy.imageUrl = imageUrl;
        $scope.saveUser();
      });
    };
    $scope.showPasswordRequirements = function () {
      $scope.showRequirementsText = !$scope.showRequirementsText;
    };

    //delete image url from organization
    $scope.clearImage = function () {
      $scope.editCopy.imageUrl = null;
      $scope.saveUser();
    };
    $scope.saveUser = function () {
      var validationRules = {
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.editCopy.name
        },
        "email": {
          "rules": {
            "required": true,
            "email": true
          },
          "value": $scope.editCopy.email
        },
        "gravatarEmail": {
          "display": "Gravatar email",
          "rules": {
            "required": true,
            "email": true
          },
          "value": $scope.editCopy.gravatarEmail
        }
      };
      if ($scope.editing.password === true) {
        _.extend(validationRules, {
          "currentPassword": {
            "display": "Current password",
            "rules": {
              "required": true
            },
            "value": $scope.editCopy.currentPassword
          },
          "password": {
            "rules": {
              "required": true,
              "password": true
            },
            "value": $scope.editCopy.password
          },
          "passwordConfirm": {
            "display": "Password confirmation",
            "rules": {
              "requiredWith": ["password"],
              "matches": "password"
            },
            "value": $scope.editCopy.passwordConfirm
          }
        });
      }
      $scope.formErrors = Validation.validate(validationRules);
      if ($scope.formErrors !== null) {
        $scope.showRequirementsText = true;
        return;
      }
      $scope.saving = true;
      $scope.editCopy.requireCurrentPassword = true;
      $http.put(Api.url("/users/" + $scope.user.user.id, true), $scope.editCopy).then(function updateUserSuccess() {
        delete $scope.editCopy.currentPassword;
        delete $scope.editCopy.password;
        delete $scope.editCopy.passwordConfirm;

        //Update the current user with what's on the form
        $scope.user.user = $scope.editCopy;
        User.set($scope.user);
        updateUserScope();
        $scope.resetEditingState();
        $scope.saving = false;
        Alerts.raiseAlert({
          type: "success",
          text: "Your account information has been updated."
        });
      }, function updateUserError(response) {
        Logger.error("An error occurred updating user with ID " + $scope.user.user.id + ", response status " + response.status);
        $scope.saveError = "There was an error updating your account. ";
        if (response.data && response.data.message) {
          $scope.saveError += response.data.message;
        }
        $scope.saving = false;
      });
    };
    $scope.saveEmailPreferences = function () {
      $scope.savingEmailPreferences = true;
      if ($scope.userIsUnsubscribed) {
        $http['delete'](Api.url("/email-blacklist/" + $scope.user.user.email, true)).then(function deleteEmailSuccess() {
          $scope.userIsUnsubscribed = false;
          $scope.savingEmailPreferences = false;
          $scope.saveEmailPreferencesError = null;
        }, function deleteEmailError(response) {
          if (response.status === 404) {
            $scope.userIsUnsubscribed = false;
            $scope.saveEmailPreferencesError = null;
          } else {
            $scope.saveEmailPreferencesError = "There was an error updating your email preferences.";
          }
          $scope.savingEmailPreferences = false;
        });
      } else {
        $http.post(Api.url("/email-blacklist", true), {
          email: $scope.user.user.email
        }).then(function addEmailSuccess() {
          $scope.userIsUnsubscribed = true;
          $scope.savingEmailPreferences = false;
          $scope.saveEmailPreferencesError = null;
        }, function addEmailError(response) {
          if (response.status === 409) {
            $scope.userIsUnsubscribed = true;
            $scope.saveEmailPreferencesError = null;
          } else {
            $scope.saveEmailPreferencesError = "There was an error updating your email preferences.";
          }
          $scope.savingEmailPreferences = false;
        });
      }
    };
    $scope.resetEditingState = function () {
      $scope.editCopy = angular.copy(User.get().user);
      //Set default value for gravatar email
      if (!$scope.editCopy.gravatarEmail) {
        $scope.editCopy.gravatarEmail = $scope.editCopy.email;
      }
      delete $scope.editCopy.currentPassword;
      delete $scope.editCopy.password;
      delete $scope.editCopy.passwordConfirm;
      $scope.saving = false;
      $scope.formErrors = null;
      $scope.saveError = null;
      $scope.editing = {};
      $scope.showRequirementsText = false;
    };
    $scope.resetEditingState();
  }]);
})();
